import { render, staticRenderFns } from "./PdfPreviewDisplay.vue?vue&type=template&id=60b247ea&scoped=true"
import script from "./PdfPreviewDisplay.vue?vue&type=script&lang=js"
export * from "./PdfPreviewDisplay.vue?vue&type=script&lang=js"
import style0 from "./PdfPreviewDisplay.vue?vue&type=style&index=0&id=60b247ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b247ea",
  null
  
)

export default component.exports